export function Sertificate() {
  return (
    <div className="container-fluid">
      <div>
        <h1>Подарочный сертификат</h1>
      </div>
      <div className="row p-5">
        <div className="col-xxl-6">
          <p className="">
            Вы можете заказать индивидуальный подарочный сертификат на
            фотосессию для своих близких.
          </p>
          <p>
            Сертификат именной и разрабатывается по заказу. 
             </p>
          <p>
            Длительность съемки 1 или 2 часа.  
          </p>
            <p>
            Стоимость 5 000 рублей или 10 000 рублей. 
          </p>

            <p>
            Нажимайте кнопку "Записаться". 
          </p>
        </div>

        <div className="col-xxl-6">
          <img className="imgI" src={require("./materials/sert.png")} alt={3} />
        </div>
      </div>
    </div>
  );
}
